<template>
  <div class="w-screen min-h-screen overflow-y-auto overflow-x-hidden bg-gray-50 relative pb-20">
    <div class="w-full min-h-screen overflow-y-auto overflow-x-hidden relative">

      <!-- Header -->
      <div
        class="w-full bg-white px-4 py-3 border-b border-gray-200 flex justify-between items-center print:hidden shadow-sm">
        <div class="font-bold text-blue-600">E-TRANSAKSI</div>
        <svg @click="logout" xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 stroke-current text-red-500 cursor-pointer hover:text-red-700 transition" fill="none"
          viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
        </svg>
      </div>

      <!-- Content -->
      <div class="p-4 max-w-7xl mx-auto">
        <!-- Title -->
        <div class="text-center mb-6">
          <h5 class="font-bold text-blue-700 text-lg">JOB SHEET</h5>
          <h6 class="font-bold text-red-500">EF-PRINT</h6>
        </div>

        <div class="flex justify-end gap-2 mb-4">
          <button @click="$router.push({ name: 'CreateJobSheetIndividual' })"
            class="bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded-md font-semibold text-sm flex items-center gap-2 shadow-sm transition">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
            </svg>
            Tambah Individual
          </button>
          <button @click="$router.push({ name: 'CreateJobSheet' })"
            class="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-md font-semibold text-sm flex items-center gap-2 shadow-sm transition">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
            </svg>
            Tambah Job Baliho
          </button>
        </div>

        <!-- Tabs -->
        <div class="flex border-b border-gray-200 mb-4">
          <button @click="activeTab = 'kelompok'"
            :class="activeTab === 'kelompok' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
            class="whitespace-nowrap py-3 px-6 border-b-2 font-bold text-sm transition flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            Job Baliho
          </button>
          <button @click="activeTab = 'individual'"
            :class="activeTab === 'individual' ? 'border-green-600 text-green-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
            class="whitespace-nowrap py-3 px-6 border-b-2 font-bold text-sm transition flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            Individual
          </button>
        </div>

        <!-- Data Table -->
        <div class="mb-4 overflow-x-auto bg-white rounded-lg shadow-sm border border-gray-200">
          <table class="w-full text-sm text-left">
            <thead class="bg-gray-100 text-gray-700 uppercase text-xs">
              <tr>
                <th class="px-3 py-3 w-10 text-center"></th>
                <th class="px-3 py-3 text-center font-bold whitespace-nowrap border-b">NO JS</th>
                <th v-if="activeTab === 'individual'" class="px-3 py-3 text-center font-bold whitespace-nowrap border-b">PERSONIL</th>
                <th class="px-3 py-3 text-center font-bold whitespace-nowrap border-b">TANGGAL</th>
                <th class="px-3 py-3 text-center font-bold border-b">PELANGGAN</th>
                <th v-if="activeTab !== 'individual'" class="px-3 py-3 text-center font-bold border-b">TEMPAT</th>
                <th class="px-3 py-3 text-center font-bold whitespace-nowrap border-b">UKURAN</th>
                <th class="px-3 py-3 text-center font-bold whitespace-nowrap border-b">JML. PASANG</th>
                <th class="px-3 py-3 text-center font-bold border-b">WAKTU</th>
                <th v-if="activeTab === 'individual'" class="px-3 py-3 text-center font-bold border-b">SELESAI</th>
                <th class="px-3 py-3 text-center font-bold border-b">AKSI</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="filteredJobSheets.length === 0 && !isLoading">
                <td :colspan="activeTab === 'individual' ? 10 : 9" class="px-4 py-8 text-center text-gray-500 italic border-b">Belum ada data job sheet
                </td>
              </tr>
              <tr v-if="isLoading">
                <td :colspan="activeTab === 'individual' ? 10 : 9" class="px-4 py-8 text-center text-gray-500 border-b">Loading data...</td>
              </tr>
              <template v-for="js in filteredJobSheets" :key="js.id">
                <tr
                  :class="js.type === 'individual' && hasIndividualProblem(js) ? 'bg-yellow-50 hover:bg-yellow-100' : 'hover:bg-blue-50'"
                  class="border-b transition duration-150"
                >
                  <td class="px-2 py-2 text-center align-middle">
                    <button @click="toggleRow(js.id)"
                      class="text-gray-500 hover:text-blue-600 focus:outline-none transition p-1 rounded-full hover:bg-gray-200">
                      <svg v-if="expandedRows.includes(js.id)" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5"
                        viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd"
                          d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                          clip-rule="evenodd" />
                      </svg>
                      <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20"
                        fill="currentColor">
                        <path fill-rule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clip-rule="evenodd" />
                      </svg>
                    </button>
                  </td>
                  <td class="px-3 py-3 text-center font-semibold text-gray-800">
                    <div class="flex items-center justify-center gap-1.5">
                      <span>{{ js.job_sheet_no }}</span>
                      <span
                        v-if="js.type === 'individual' && hasIndividualProblem(js)"
                        :title="js.problem_note"
                        class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-yellow-100 text-yellow-800 text-[10px] font-bold"
                      >⚠ Bermasalah</span>
                      <!-- Icon Completed: muncul saat semua upah personil sudah terisi -->
                      <span
                        v-if="js.type !== 'individual' && isUpahCompleted(js.id)"
                        title="Pembagian upah personil sudah lengkap"
                        class="inline-flex items-center justify-center w-5 h-5 rounded-full bg-green-100 text-green-600 shrink-0"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" viewBox="0 0 20 20" fill="currentColor">
                          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                        </svg>
                      </span>
                    </div>
                  </td>
                  <td v-if="activeTab === 'individual'" class="px-3 py-3 text-center whitespace-nowrap font-semibold">{{ js.pic_nama || '-' }}</td>
                  <td class="px-3 py-3 text-center whitespace-nowrap">{{ js.tanggal }}</td>
                  <td class="px-3 py-3 text-center">{{ js.pelanggan_nama || '-' }}</td>
                  <td v-if="activeTab !== 'individual'" class="px-3 py-3 text-center" :title="js.tempat">
                    <div style="max-width: 200px;" class="truncate mx-auto">{{ js.type === 'individual' ? '-' :
                      js.tempat }}</div>
                  </td>
                  <td class="px-3 py-3 text-center">{{ js.type === 'individual' ? '-' : js.ukuran }}</td>
                  <td class="px-3 py-3 text-center font-bold text-blue-600">{{ js.type === 'individual' ? '-' :
                    js.jumlah_pasang }}</td>
                  <td class="px-3 py-3 text-center whitespace-nowrap">
                    <button v-if="js.type === 'individual'" @click="openProblemModal(js)"
                      class="text-orange-600 hover:text-orange-800 mr-2" :title="hasIndividualProblem(js) ? 'Lihat atau ubah masalah' : 'Catat masalah'">⚠️</button>
                    <template v-if="js.type === 'individual'">
                      <span class="text-[11px] text-gray-500">Target:</span><br>
                      <span class="font-semibold">{{ js.target_finish || '-' }}</span>
                    </template>
                    <template v-else>
                      <span class="capitalize">{{ js.waktu_berangkat }}</span><br>
                      <span v-if="js.selesai_pukul" class="text-gray-500 text-[11px]">s.d {{ js.selesai_pukul }}</span>
                    </template>
                  </td>
                  <td v-if="activeTab === 'individual'" class="px-3 py-3 text-center">
                    <label class="inline-flex items-center justify-center cursor-pointer" :title="isIndividualCompleted(js) ? 'Pekerjaan selesai' : 'Tandai pekerjaan selesai'">
                      <input
                        type="checkbox"
                        class="h-5 w-5 text-green-600 border-gray-300 rounded focus:ring-green-500 disabled:opacity-50"
                        :checked="isIndividualCompleted(js)"
                        :disabled="completionLoading[js.id]"
                        @change="toggleIndividualCompletion(js, $event.target.checked, $event)"
                      >
                    </label>
                  </td>
                  <td class="px-3 py-3 text-center whitespace-nowrap">
                    <button v-if="js.type !== 'individual'" @click="printJobSheet(js.id)"
                      class="text-blue-600 hover:text-blue-800 mr-2" title="Cetak Job Sheet">🖨️</button>
                    <button v-if="js.type !== 'individual'" @click="downloadJobSheet(js.id)"
                      class="text-purple-600 hover:text-purple-800 mr-2" title="Download Gambar Job Sheet">⬇️</button>
                    <button v-if="js.type === 'individual'" @click="printKartu(js.id)"
                      class="text-green-600 hover:text-green-800 mr-2" title="Cetak Kartu Individual">🏷️</button>
                    <button v-if="js.type === 'individual'" @click="downloadKartu(js.id)"
                      class="text-purple-600 hover:text-purple-800 mr-2"
                      title="Download Gambar Kartu Individual">⬇️</button>
                    <button
                      @click="$router.push({ name: js.type === 'individual' ? 'EditJobSheetIndividual' : 'EditJobSheet', params: { id: js.id } })"
                      class="text-yellow-600 hover:text-yellow-800 mr-2" title="Edit">✏️</button>
                    <button @click="deleteJobSheet(js.id)" class="text-red-600 hover:text-red-800"
                      title="Hapus">🗑️</button>
                  </td>
                </tr>

                <!-- Expanded Row -->
                <tr v-if="expandedRows.includes(js.id)" class="bg-blue-50 border-b border-gray-200">
                  <td :colspan="activeTab === 'individual' ? 10 : 9" class="p-4">

                    <!-- ===== TIPE INDIVIDUAL ===== -->
                    <div v-if="js.type === 'individual'"
                      class="bg-white p-3 rounded-lg shadow-sm border border-blue-100">
                      <!-- Loading -->
                      <div v-if="individualWorkerLoading[js.id]" class="text-blue-600 text-sm animate-pulse">Loading...
                      </div>
                      <template v-else-if="individualWorker[js.id]">
                        <div class="flex flex-wrap items-center gap-x-6 gap-y-1">
                          <div v-if="individualWorker[js.id].catatan" class="flex items-center gap-1.5 min-w-0 flex-1">
                            <span
                              class="text-[10px] text-gray-400 uppercase font-bold tracking-wider shrink-0">Deskripsi
                              Pekerjaan:</span>
                            <span class="text-gray-700 text-xs truncate" :title="individualWorker[js.id].catatan">{{
                              individualWorker[js.id].catatan }}</span>
                          </div>
                          <div v-else class="text-gray-400 text-xs italic">Tidak ada deskripsi pekerjaan.</div>
                        </div>
                      </template>
                      <p v-else class="text-gray-400 text-xs italic">Data tidak tersedia.</p>
                    </div>

                    <!-- ===== TIPE BALIHO/KELOMPOK ===== -->
                    <!-- Layout: kiri Detail Pekerjaan (col-span-2), kanan Pembagian Upah (col-span-1) -->
                    <div v-else
                      class="grid grid-cols-1 md:grid-cols-3 gap-6 bg-white p-4 rounded-lg shadow-sm border border-blue-100">

                      <!-- ---- KIRI: Detail Pekerjaan (lebar 2/3) ---- -->
                      <div class="md:col-span-2 relative">
                        <!-- Loading overlay -->
                        <div v-if="workDetailLoading[js.id]"
                          class="absolute inset-0 bg-white/80 z-10 flex items-center justify-center rounded">
                          <span class="text-blue-600 font-semibold animate-pulse">Loading...</span>
                        </div>

                        <div class="flex items-center justify-between mb-2 border-b pb-1">
                          <h6 class="font-bold text-gray-700">Detail Pekerjaan</h6>
                          <button @click="showAddWorkDetail(js.id)"
                            class="bg-blue-600 hover:bg-blue-700 text-white text-xs font-bold px-3 py-1 rounded flex items-center gap-1 transition">
                            <span>+</span> Tambah
                          </button>
                        </div>

                        <!-- Form Tambah / Edit -->
                        <div v-if="workDetailForm[js.id] && workDetailForm[js.id].show"
                          class="mb-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                          <div class="grid grid-cols-12 gap-2 items-end">
                            <div class="col-span-12 sm:col-span-5">
                              <label class="text-[10px] text-gray-500 font-bold block">Nama Pekerjaan</label>
                              <input type="text" v-model="workDetailForm[js.id].nama_pekerjaan"
                                placeholder="Contoh: Merangka"
                                class="w-full mt-1 border border-gray-300 rounded px-2 py-1 text-xs focus:outline-none focus:border-blue-500">
                            </div>
                            <div class="col-span-4 sm:col-span-2">
                              <label class="text-[10px] text-gray-500 font-bold block text-center">Jumlah</label>
                              <input type="number" v-model.number="workDetailForm[js.id].jumlah" min="1"
                                class="w-full mt-1 border border-gray-300 rounded px-2 py-1 text-xs focus:outline-none focus:border-blue-500 text-center">
                            </div>
                            <div class="col-span-8 sm:col-span-3">
                              <label class="text-[10px] text-gray-500 font-bold block">Harga (Rp)</label>
                              <input type="text"
                                :value="getDisplayValue(workDetailForm[js.id].harga, focusedField === 'harga_form_' + js.id)"
                                @focus="focusedField = 'harga_form_' + js.id" @blur="focusedField = null"
                                @input="workDetailForm[js.id].harga = unformatNumber($event.target.value)"
                                placeholder="0"
                                class="w-full mt-1 border border-gray-300 rounded px-2 py-1 text-xs focus:outline-none focus:border-blue-500">
                            </div>
                            <div class="col-span-12 sm:col-span-2 flex gap-1 justify-end">
                              <button @click="saveWorkDetail(js.id)"
                                class="bg-green-600 hover:bg-green-700 text-white text-xs font-bold px-2 py-1 rounded transition">
                                {{ workDetailForm[js.id].editId ? 'Update' : 'Simpan' }}
                              </button>
                              <button @click="cancelWorkDetailForm(js.id)"
                                class="bg-gray-300 hover:bg-gray-400 text-gray-700 text-xs font-bold px-2 py-1 rounded transition">
                                Batal
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Tabel Detail Pekerjaan -->
                        <div class="overflow-x-auto">
                          <table class="w-full text-xs">
                            <thead class="bg-gray-100 text-gray-600 uppercase">
                              <tr>
                                <th class="px-2 py-2 text-left font-bold">Nama Pekerjaan</th>
                                <th class="px-2 py-2 text-center font-bold w-14">Jml</th>
                                <th class="px-2 py-2 text-right font-bold">Harga</th>
                                <th class="px-2 py-2 text-right font-bold">Total</th>
                                <th class="px-2 py-2 text-center font-bold w-16">Aksi</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-if="!workDetails[js.id] || workDetails[js.id].length === 0">
                                <td colspan="5" class="px-2 py-3 text-center text-gray-400 italic">Belum ada detail
                                  pekerjaan</td>
                              </tr>
                              <tr v-for="wd in workDetails[js.id]" :key="wd.id"
                                class="border-b border-gray-100 hover:bg-gray-50">
                                <td class="px-2 py-2 text-gray-800">{{ wd.nama_pekerjaan }}</td>
                                <td class="px-2 py-2 text-center">{{ wd.jumlah }}</td>
                                <td class="px-2 py-2 text-right">{{ formatRupiah(wd.harga) }}</td>
                                <td class="px-2 py-2 text-right font-semibold text-blue-700">{{ formatRupiah(wd.total)
                                  }}</td>
                                <td class="px-2 py-2 text-center whitespace-nowrap">
                                  <button @click="editWorkDetail(js.id, wd)"
                                    class="text-yellow-600 hover:text-yellow-800 mr-1" title="Edit">✏️</button>
                                  <button @click="deleteWorkDetail(js.id, wd.id)"
                                    class="text-red-600 hover:text-red-800" title="Hapus">🗑️</button>
                                </td>
                              </tr>
                              <!-- Grand Total -->
                              <tr v-if="workDetails[js.id] && workDetails[js.id].length > 0"
                                class="bg-blue-50 font-bold">
                                <td colspan="3"
                                  class="px-2 py-2 text-right text-gray-600 text-xs uppercase tracking-wide">Grand Total
                                </td>
                                <td class="px-2 py-2 text-right text-blue-700">
                                  {{ formatRupiah(grandTotalWorkDetails(js.id)) }}
                                </td>
                                <td></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <!-- ---- KANAN: Pembagian Upah (1/3) ---- -->
                      <div class="md:col-span-1 relative">
                        <!-- Loading overlay -->
                        <div v-if="upahLoading[js.id]"
                          class="absolute inset-0 bg-white/80 z-10 flex items-center justify-center rounded">
                          <span class="text-blue-600 font-semibold animate-pulse">Loading...</span>
                        </div>

                        <h6 class="font-bold text-gray-700 mb-2 border-b pb-1">Pembagian Upah</h6>

                        <div v-if="upahData[js.id] && upahData[js.id].length > 0" class="space-y-1">
                          <div v-for="(det, didx) in upahData[js.id]" :key="didx"
                            class="py-1 flex items-center justify-between gap-2 border-b border-gray-100 last:border-b-0">
                            <!-- Nama Personil + Role -->
                            <div class="flex items-center gap-1 min-w-0 flex-1">
                              <span class="text-xs font-semibold text-gray-800 truncate" :title="det.personil_nama">
                                {{ det.personil_nama }}
                              </span>
                              <span
                                class="text-[8px] bg-gray-200 text-gray-700 px-1.5 py-0.5 rounded font-bold uppercase whitespace-nowrap shrink-0">
                                {{ det.role_pekerjaan }}
                              </span>
                            </div>
                            <!-- Upah Input -->
                            <div class="shrink-0">
                              <input type="text"
                                :value="getDisplayValue(det.nominal_upah, focusedField === 'upah_' + js.id + '_' + didx)"
                                @focus="focusedField = 'upah_' + js.id + '_' + didx" @blur="focusedField = null"
                                @input="det.nominal_upah = unformatNumber($event.target.value)" placeholder="0"
                                class="w-28 border border-gray-300 rounded px-2 py-0.5 text-xs focus:outline-none focus:border-blue-500 text-right">
                            </div>
                          </div>
                          <!-- Perbandingan Total Upah vs Grand Total Pekerjaan -->
                          <div class="pt-2 mt-2 border-t border-gray-300">
                            <div class="flex justify-between items-center">
                              <span class="text-xs font-bold text-gray-700">Total Upah:</span>
                              <span class="text-xs font-bold text-blue-700">{{ formatRupiah(totalUpah(js.id)) }}</span>
                            </div>
                            <div v-if="grandTotalWorkDetails(js.id) > 0" class="text-[10px] mt-1 text-right">
                              <span v-if="totalUpah(js.id) === grandTotalWorkDetails(js.id)" class="text-green-600 font-bold">
                                ✓ Sesuai dengan Detail Pekerjaan
                              </span>
                              <span v-else-if="totalUpah(js.id) < grandTotalWorkDetails(js.id)" class="text-yellow-600 font-bold">
                                ⚠ Sisa (Kurang) {{ formatRupiah(grandTotalWorkDetails(js.id) - totalUpah(js.id)) }}
                              </span>
                              <span v-else class="text-red-600 font-bold">
                                ⚠ Kelebihan {{ formatRupiah(totalUpah(js.id) - grandTotalWorkDetails(js.id)) }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <p v-else class="text-gray-400 text-sm italic">Tidak ada personil terdaftar.</p>

                        <!-- Tombol Simpan -->
                        <div class="mt-3 pt-3 border-t border-gray-200">
                          <button @click="saveUpah(js.id)"
                            class="w-full bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded text-sm font-bold shadow-sm transition">
                            Simpan Pembayaran
                          </button>
                        </div>
                      </div>

                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Modal masalah pekerjaan individual -->
      <div v-if="problemModal.show" class="fixed inset-0 z-50 overflow-y-auto bg-black bg-opacity-50 p-4">
        <div style="max-height: calc(100vh - 2rem);" class="mx-auto flex w-full max-w-md flex-col overflow-hidden rounded-lg bg-white shadow-xl">
          <div class="flex items-start justify-between gap-4 border-b border-gray-100 px-5 py-4">
            <div>
              <h6 class="font-bold text-gray-800">Masalah Pekerjaan</h6>
              <p class="mt-1 text-xs text-gray-500">{{ problemModal.jobSheet ? problemModal.jobSheet.job_sheet_no : '' }}</p>
            </div>
            <button @click="closeProblemModal" class="text-xl leading-none text-gray-400 hover:text-gray-700">×</button>
          </div>

          <div class="overflow-y-auto px-5 py-4">
            <label class="mb-1 block text-xs font-bold text-gray-600">Keterangan masalah</label>
            <textarea
              v-model.trim="problemModal.note"
              rows="4"
              maxlength="1000"
              placeholder="Contoh: mesin rusak, mati lampu, bahan belum tersedia"
              class="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-orange-500 focus:outline-none"
            ></textarea>
            <p v-if="problemModal.error" class="mt-1 text-xs text-red-600">{{ problemModal.error }}</p>
          </div>

          <div class="flex shrink-0 flex-wrap justify-end gap-2 border-t border-gray-100 bg-white px-5 py-4">
            <button
              v-if="problemModal.jobSheet && hasIndividualProblem(problemModal.jobSheet)"
              @click="clearIndividualProblem"
              :disabled="problemModal.loading"
              class="rounded-md border border-green-600 px-3 py-2 text-xs font-bold text-green-700 hover:bg-green-50 disabled:opacity-50"
            >Masalah Selesai</button>
            <button @click="closeProblemModal" :disabled="problemModal.loading"
              class="rounded-md border border-gray-300 px-3 py-2 text-xs font-bold text-gray-600 hover:bg-gray-50 disabled:opacity-50">Batal</button>
            <button @click="saveIndividualProblem" :disabled="problemModal.loading"
              class="rounded-md border border-blue-700 bg-blue-600 px-4 py-2 text-xs font-bold text-white shadow-sm hover:bg-blue-700 disabled:opacity-50">
              {{ problemModal.loading ? 'Menyimpan...' : 'Simpan' }}
            </button>
          </div>
        </div>
      </div>

      <bottom-nav></bottom-nav>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import BottomNav from '../components/BottomNav.vue'

export default {
  name: 'JobSheet',
  components: { BottomNav },
  data() {
    return {
      isLoading: false,
      activeTab: 'kelompok',
      jobSheets: [],
      expandedRows: [],
      // Individual worker
      individualWorker: {},
      individualWorkerLoading: {},
      completionLoading: {},
      problemModal: {
        show: false,
        jobSheet: null,
        note: '',
        error: '',
        loading: false
      },
      // Upah (Pembagian Upah)
      upahData: {},
      upahLoading: {},
      // Detail Pekerjaan
      workDetails: {},
      workDetailLoading: {},
      workDetailForm: {}, // { [js.id]: { show, editId, nama_pekerjaan, jumlah, harga } }
      // Input format
      focusedField: null
    }
  },
  computed: {
    filteredJobSheets() {
      // Pastikan property 'type' pada data sesuai, misal 'kelompok' atau 'individual'
      return this.jobSheets.filter(js => (js.type || 'kelompok') === this.activeTab)
    }
  },
  mounted() {
    this.fetchJobSheets()
  },
  methods: {
    isIndividualCompleted(jobSheet) {
      return Number(jobSheet.is_completed) === 1
    },

    hasIndividualProblem(jobSheet) {
      return Number(jobSheet.has_problem) === 1
    },

    openProblemModal(jobSheet) {
      this.problemModal = {
        show: true,
        jobSheet,
        note: jobSheet.problem_note || '',
        error: '',
        loading: false
      }
    },

    closeProblemModal() {
      if (this.problemModal.loading) return
      this.problemModal.show = false
    },

    async saveIndividualProblem() {
      if (!this.problemModal.note) {
        this.problemModal.error = 'Keterangan masalah wajib diisi.'
        return
      }
      await this.updateIndividualProblem(true, this.problemModal.note)
    },

    async clearIndividualProblem() {
      await this.updateIndividualProblem(false, '')
    },

    async updateIndividualProblem(hasProblem, note) {
      const jobSheet = this.problemModal.jobSheet
      this.problemModal.loading = true
      this.problemModal.error = ''

      try {
        const formData = new FormData()
        formData.append('has_problem', hasProblem ? '1' : '0')
        formData.append('problem_note', note)
        formData.append('token', this.$store.state.token)
        const response = await axios.post(`/e_transaksi/job_sheet/set_problem/${jobSheet.id}`, formData)
        if (!response.data.status) throw new Error(response.data.message || 'Gagal menyimpan masalah')

        jobSheet.has_problem = hasProblem ? 1 : 0
        jobSheet.problem_note = hasProblem ? note : null
        jobSheet.problem_at = response.data.problem_at
        if (hasProblem) {
          jobSheet.is_completed = 0
          jobSheet.completed_at = null
        }
        this.problemModal.show = false
      } catch (error) {
        this.problemModal.error = error.response?.data?.message || error.message || 'Terjadi kesalahan saat menyimpan masalah.'
      } finally {
        this.problemModal.loading = false
      }
    },

    async toggleIndividualCompletion(jobSheet, isCompleted, event) {
      if (isCompleted && this.hasIndividualProblem(jobSheet) && !confirm('Pekerjaan sedang ditandai bermasalah. Tandai selesai dan hapus status masalah?')) {
        event.target.checked = false
        return
      }
      const previousValue = jobSheet.is_completed
      jobSheet.is_completed = isCompleted ? 1 : 0
      this.completionLoading = { ...this.completionLoading, [jobSheet.id]: true }

      try {
        const formData = new FormData()
        formData.append('is_completed', isCompleted ? '1' : '0')
        formData.append('token', this.$store.state.token)

        const response = await axios.post(`/e_transaksi/job_sheet/set_completion/${jobSheet.id}`, formData)
        if (!response.data.status) {
          throw new Error(response.data.message || 'Gagal memperbarui status pekerjaan')
        }

        jobSheet.completed_at = response.data.completed_at
        if (isCompleted) {
          jobSheet.has_problem = 0
          jobSheet.problem_note = null
          jobSheet.problem_at = null
        }
      } catch (error) {
        jobSheet.is_completed = previousValue
        console.error('Failed to update individual completion:', error)
        alert(error.response?.data?.message || error.message || 'Terjadi kesalahan saat memperbarui status pekerjaan.')
      } finally {
        this.completionLoading = { ...this.completionLoading, [jobSheet.id]: false }
      }
    },

    // ─── Helper: cek apakah semua personil upah sudah terisi nilainya ─────
    isUpahCompleted(jobSheetId) {
      const items = this.upahData[jobSheetId]
      if (!items || items.length === 0) return false
      return items.every(d => parseFloat(d.nominal_upah) > 0)
    },

    // ─── Job Sheets ────────────────────────────────────────────────
    async fetchJobSheets() {
      this.isLoading = true
      try {
        const response = await axios.get('/e_transaksi/job_sheet/get_all', {
          params: { token: this.$store.state.token }
        })
        if (response.data.status) {
          this.jobSheets = response.data.data
          // Pre-fetch upah data semua job kelompok agar icon completed
          // langsung terlihat tanpa perlu expand row terlebih dahulu
          const kelompokIds = this.jobSheets
            .filter(js => (js.type || 'kelompok') !== 'individual')
            .map(js => js.id)
          await Promise.all(kelompokIds.map(id => this.fetchUpahData(id)))
        }
      } catch (error) {
        console.error('Failed to fetch job sheets:', error)
      } finally {
        this.isLoading = false
      }
    },

    async toggleRow(id) {
      const index = this.expandedRows.indexOf(id)
      if (index === -1) {
        this.expandedRows.push(id)
        const js = this.jobSheets.find(j => j.id === id)
        if (js) {
          if (js.type === 'individual') {
            // Individual: ambil nama personil
            if (!this.individualWorker[id]) await this.fetchIndividualWorker(id)
          } else {
            // Kelompok/Baliho: ambil detail pekerjaan & upah
            if (!this.workDetails[id]) await this.fetchWorkDetails(id)
            if (!this.upahData[id]) await this.fetchUpahData(id)
          }
        }
      } else {
        this.expandedRows.splice(index, 1)
      }
    },

    // ─── Individual Worker ─────────────────────────────────────────
    async fetchIndividualWorker(id) {
      this.individualWorkerLoading = { ...this.individualWorkerLoading, [id]: true }
      try {
        const response = await axios.get(`/e_transaksi/job_sheet/get_individual_worker/${id}`, {
          params: { token: this.$store.state.token }
        })
        if (response.data.status) {
          this.individualWorker = { ...this.individualWorker, [id]: response.data.data }
        }
      } catch (error) {
        console.error('Failed to fetch individual worker:', error)
      } finally {
        this.individualWorkerLoading = { ...this.individualWorkerLoading, [id]: false }
      }
    },

    // ─── Detail Pekerjaan ──────────────────────────────────────────
    async fetchWorkDetails(jobSheetId) {
      this.workDetailLoading = { ...this.workDetailLoading, [jobSheetId]: true }
      try {
        const response = await axios.get(`/e_transaksi/job_sheet_work_detail/get_by_job_sheet/${jobSheetId}`, {
          params: { token: this.$store.state.token }
        })
        if (response.data.status) {
          this.workDetails = { ...this.workDetails, [jobSheetId]: response.data.data }
        }
      } catch (error) {
        console.error('Failed to fetch work details:', error)
      } finally {
        this.workDetailLoading = { ...this.workDetailLoading, [jobSheetId]: false }
      }
    },

    showAddWorkDetail(jobSheetId) {
      this.workDetailForm = {
        ...this.workDetailForm,
        [jobSheetId]: {
          show: true,
          editId: null,
          nama_pekerjaan: '',
          jumlah: 1,
          harga: 0
        }
      }
    },

    editWorkDetail(jobSheetId, wd) {
      this.workDetailForm = {
        ...this.workDetailForm,
        [jobSheetId]: {
          show: true,
          editId: wd.id,
          nama_pekerjaan: wd.nama_pekerjaan,
          jumlah: wd.jumlah,
          harga: parseFloat(wd.harga)
        }
      }
    },

    cancelWorkDetailForm(jobSheetId) {
      this.workDetailForm = {
        ...this.workDetailForm,
        [jobSheetId]: { show: false, editId: null, nama_pekerjaan: '', jumlah: 1, harga: 0 }
      }
    },

    async saveWorkDetail(jobSheetId) {
      const form = this.workDetailForm[jobSheetId]
      if (!form || !form.nama_pekerjaan.trim()) {
        alert('Nama Pekerjaan wajib diisi.')
        return
      }

      const payload = {
        job_sheet_id: jobSheetId,
        nama_pekerjaan: form.nama_pekerjaan.trim(),
        jumlah: form.jumlah,
        harga: form.harga
      }

      this.workDetailLoading = { ...this.workDetailLoading, [jobSheetId]: true }
      try {
        let response
        if (form.editId) {
          response = await axios.post(`/e_transaksi/job_sheet_work_detail/update/${form.editId}`, payload, {
            params: { token: this.$store.state.token }
          })
        } else {
          response = await axios.post('/e_transaksi/job_sheet_work_detail/store', payload, {
            params: { token: this.$store.state.token }
          })
        }

        if (response.data.status) {
          this.cancelWorkDetailForm(jobSheetId)
          await this.fetchWorkDetails(jobSheetId)
        } else {
          alert('Gagal menyimpan: ' + response.data.message)
        }
      } catch (error) {
        console.error('Failed to save work detail:', error)
        alert('Terjadi kesalahan saat menyimpan.')
      } finally {
        this.workDetailLoading = { ...this.workDetailLoading, [jobSheetId]: false }
      }
    },

    async deleteWorkDetail(jobSheetId, detailId) {
      if (!confirm('Hapus detail pekerjaan ini?')) return

      this.workDetailLoading = { ...this.workDetailLoading, [jobSheetId]: true }
      try {
        const response = await axios.post(`/e_transaksi/job_sheet_work_detail/delete/${detailId}`, null, {
          params: { token: this.$store.state.token }
        })
        if (response.data.status) {
          await this.fetchWorkDetails(jobSheetId)
        } else {
          alert('Gagal menghapus: ' + response.data.message)
        }
      } catch (error) {
        console.error('Failed to delete work detail:', error)
        alert('Terjadi kesalahan saat menghapus.')
      } finally {
        this.workDetailLoading = { ...this.workDetailLoading, [jobSheetId]: false }
      }
    },

    grandTotalWorkDetails(jobSheetId) {
      const items = this.workDetails[jobSheetId]
      if (!items || !items.length) return 0
      return items.reduce((sum, wd) => sum + (parseFloat(wd.total) || 0), 0)
    },

    // ─── Pembagian Upah ────────────────────────────────────────────
    totalUpah(jobSheetId) {
      const items = this.upahData[jobSheetId]
      if (!items || !items.length) return 0
      return items.reduce((sum, d) => sum + (parseFloat(d.nominal_upah) || 0), 0)
    },

    async fetchUpahData(jobSheetId) {
      this.upahLoading = { ...this.upahLoading, [jobSheetId]: true }
      try {
        const response = await axios.get(`/e_transaksi/job_sheet_upah/get/${jobSheetId}`, {
          params: { token: this.$store.state.token }
        })
        if (response.data.status) {
          this.upahData = { ...this.upahData, [jobSheetId]: response.data.data }
        }
      } catch (error) {
        console.error('Failed to fetch upah data:', error)
      } finally {
        this.upahLoading = { ...this.upahLoading, [jobSheetId]: false }
      }
    },

    async saveUpah(id) {
      const details = this.upahData[id]
      if (!details) return

      this.upahLoading = { ...this.upahLoading, [id]: true }
      try {
        const response = await axios.post('/e_transaksi/job_sheet_upah/save', {
          job_sheet_id: id,
          details: details.map(d => ({
            id_user: d.id_user,
            role_pekerjaan: d.role_pekerjaan,
            nominal_upah: d.nominal_upah
          }))
        }, {
          params: { token: this.$store.state.token }
        })

        if (response.data.status) {
          alert('Pembayaran berhasil disimpan!')
        } else {
          alert('Gagal menyimpan: ' + response.data.message)
        }
      } catch (error) {
        console.error('Failed to save upah:', error)
        alert('Terjadi kesalahan saat menyimpan data.')
      } finally {
        this.upahLoading = { ...this.upahLoading, [id]: false }
      }
    },

    // ─── Hapus Job Sheet ───────────────────────────────────────────
    async deleteJobSheet(id) {
      if (!confirm('Apakah Anda yakin ingin menghapus Job Sheet ini? Data terkait seperti personil dan pembayaran juga akan ikut terhapus.')) {
        return
      }

      this.isLoading = true
      try {
        const response = await axios.post(`/e_transaksi/job_sheet/delete/${id}`, null, {
          params: { token: this.$store.state.token }
        })

        if (response.data.status) {
          alert('Job Sheet berhasil dihapus.')
          this.fetchJobSheets()
        } else {
          alert('Gagal menghapus: ' + response.data.message)
        }
      } catch (error) {
        console.error('Failed to delete job sheet:', error)
        alert('Terjadi kesalahan saat menghapus data.')
      } finally {
        this.isLoading = false
      }
    },

    // ─── Utility ───────────────────────────────────────────────────
    formatRupiah(angka) {
      if (!angka && angka !== 0) return '0'
      return new Intl.NumberFormat('id-ID').format(angka)
    },

    getDisplayValue(val, isFocused) {
      const num = Number(val) || 0
      if (isFocused) {
        return num === 0 ? '' : num
      }
      return num === 0 ? '' : this.formatRupiah(num)
    },

    unformatNumber(val) {
      if (!val) return 0
      const num = val.toString().replace(/[^0-9]/g, '')
      return parseInt(num, 10) || 0
    },

    // ─── Auth ──────────────────────────────────────────────────────
    logout() {
      localStorage.removeItem('X-FPRINT-TOKEN')
      localStorage.removeItem('X-FPRINT-USER')
      this.$store.dispatch('set_token', null)
      this.$store.dispatch('set_user', null)
      this.$router.push({ name: 'Login' })
    },

    // ─── Print / Download ──────────────────────────────────────────
    printJobSheet(id) {
      window.open(`/print-job-sheet/${id}`, '_blank')
    },
    downloadJobSheet(id) {
      window.open(`/print-job-sheet/${id}?action=download`, '_blank')
    },
    printKartu(id) {
      window.open(`/print-kartu/${id}`, '_blank')
    },
    downloadKartu(id) {
      window.open(`/print-kartu/${id}?action=download`, '_blank')
    }
  }
}
</script>
